<template>
  <div class="field">
    <label class="label" v-if="to.label" :for="to.id ? to.id : null">{{
      to.label
    }}</label>
    <div class="control has-icons-right mt-2">
      <input
        :class="['input', { 'is-danger': hasError }, to.classes]"
        :id="to.id ? to.id : null"
        v-model="model[field.key]"
        :name="field.key"
        @blur="onBlur"
        @focus="onFocus"
        @click="onClick"
        @change="onChange"
        @keyup="onKeyup"
        @keydown="onKeydown"
        v-formly-atts="to.atts"
        type="password"
      />

      <span class="icon is-small is-right" v-if="hasError">
        <i class="fa fa-warning"></i>
      </span>
    </div>
    <div v-if="field.key != 'currentPassword'" class="help">
      <div class="bar-div">
        <div :class="getBarClass(1)"></div>
        <div :class="getBarClass(2)"></div>
        <div :class="getBarClass(3)"></div>
        <div :class="getBarClass(4)"></div>
      </div>
      <div class="strength-text">{{ strengthText }}</div>

      <p class="info" v-if="field.key != 'currentPassword'">
        A minimum of a moderate password is required. Good passwords are hard to
        guess. Use uncommon words or inside jokes, non-standard uPPercasing,
        creative spelllling, and non-obvious numbers and symbols.
      </p>
    </div>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import PasswordsService from "@/services/PasswordsService";
import baseField from "./baseField";

export default {
  mixins: [baseField],

  data() {
    return {
      strength: this.to.score,
      strengthText: "",
      strengthTexts: ["", "Weak", "Moderate", "Strong", "Very strong"],
      strengthClasses: [
        "bar weak",
        "bar weak",
        "bar moderate",
        "bar strong",
        "bar very-strong"
      ]
    };
  },

  methods: {
    onChange(e) {
      this.$set(this.form[this.field.key], "$dirty", true);

      this.runFunction("onChange", e);
      if (this.to.inputType === "file") {
        this.$set(
          this.model,
          this.field.key,
          this.$el.querySelector("input").files
        );
      }
    },

    onKeyup() {
      PasswordsService.validate({
        email: this.model.email,
        password: this.model[this.field.key]
      }).then(score => {
        this.strength = score.score || 1;
      });
    },

    getBarClass(strength) {
      let strengthClass = "bar blank";
      if (this.strength >= strength) {
        strengthClass = this.strengthClasses[this.strength];
      }

      this.strengthText = this.strengthTexts[this.strength];
      return strengthClass;
    }
  }
};
</script>

<style lang="scss">
.bar-div {
  height: 0.5rem;
  margin-top: -30px;

  .bar {
    height: 0.5rem;
    width: 24%;
    margin-right: 0.2rem;
    float: left;
  }

  .blank {
    background-color: #ccc;
  }
  .weak {
    background-color: #d42f1c;
  }
  .moderate {
    background-color: #1273dd;
  }
  .strong {
    background-color: #1273dd;
  }
  .very-strong {
    background-color: #18832b;
  }
}
.strength-text {
  font-size: 1rem;
}
.info {
  font-size: 95%;
}
</style>
